import styled from 'styled-components';

import { AiSearchBanner } from '@xing-com/crate-jobs-domain-search-ai-search-banner';
import { mediaTopBarVisible } from '@xing-com/layout-tokens';
import { Tag as BaseTag } from '@xing-com/tag';
import { spaceXS, xdlColorHoverSecondary } from '@xing-com/tokens';

const Tag = styled(BaseTag)`
  width: fit-content;

  &::after {
    transition: background-color 0.2s ease-in-out;
  }

  &:hover {
    &::after {
      background-color: ${xdlColorHoverSecondary};
      transform: none;
    }
  }

  // needed to target the tag text content
  & div > * {
    display: flex;
    align-items: center;
    gap: ${spaceXS};
  }
`;

const Banner = styled(AiSearchBanner)`
  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export { Banner, Tag };
